<div class="form-control chip-input" [class.disabled]="disabled">
  <mat-chip-grid #chipList aria-label="chip selection" class="chip-content" [disabled]="disabled">
    @for (chip of chips; track chip; let i = $index) {
      <mat-chip-row [selectable]="true" [removable]="true" (removed)="remove(chip)">
        {{ chip }}
        <svg-icon key="close" size="xs" matChipRemove />
      </mat-chip-row>
    }
    <input
      #chipInput
      [(ngModel)]="currentChip"
      [disabled]="disabled"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"

    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" class="chip-autocomplete">
    @for (chip of filteredChips; track chip) {
      <mat-option [value]="chip">{{ chip }}</mat-option>
    }
  </mat-autocomplete>
</div>
